import PropTypes from 'prop-types';
import { Cube } from "@phosphor-icons/react";
import { Box } from '@mui/joy';
import { Typography } from '@mui/joy';

export function EmptyView({
  Icon=Cube,
  text,
  heading,
  children
}) {
  return (
  <Box sx={{ aspectRatio: '16/9', width: '100%', background: 'rgba(127, 127, 127, .05)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 1 }}>
    <Box style={{flex: 1}}></Box>
    <Box sx={{ aspectRatio: '1/1', borderRadius: 100, p: 2, background: 'var(--brand-primary-background)'}}>
      <Icon weight="bold" color="var(--brand-primary-color)" size={88} />
    </Box>
    <Typography level="h3" element="h3">{heading}</Typography>
    <Typography>{text}</Typography>
    {children}
    <Box style={{flex: 1}}></Box>
  </Box>
  )
}

EmptyView.propTypes = {
  Icon: PropTypes.func,
  text: PropTypes.string,
  children: PropTypes.node,
  heading: PropTypes.string
}

export default EmptyView;